export default __webpack_public_path__ + "static/media/checklist.82b7bbd8.svg";